<template>
  <div class="vm-chat-view-wrap">
    <div class="vm-chat-view" ref="chatView">
      <transition-group name="list" tag="div">
        <div v-for="item in messages" :key="item.id">
          <Message
            :data="item"
            @clickImage="showImage(item)"
            @click="download(item.file.data)"
          />
        </div>
      </transition-group>
      <Dialog class="vm-image-dialog" v-model="showDialog">
        <img :src="src" alt="image" />
      </Dialog>
    </div>
    <button v-if="!isBottom" @click="scrollToEnd" class="vm-to-bottom" type="button">
      <span class="vm-counter" v-if="count">{{ count }}</span>
      <i class="material-icons">keyboard_arrow_down</i>
    </button>
  </div>
</template>

<script>
import Message from './FuncMessage';
import Dialog from '@app/components/uikit/Dialog';

export default {
  components: { Message, Dialog },
  data: () => ({
    showDialog: false,
    src: null,
    isBottom: true,
    count: 0,
    eps: 1,
  }),
  props: {
    messages: Array
  },
  watch: {
    messages(newState, oldState) {
      if (this.isBottom) {
        this.scrollToEnd();
      } else if (newState.length > oldState.length) {
        this.count++;
      }
    }
  },
  async mounted() {
    this.scrollToEnd();
    this.$refs.chatView.addEventListener('scroll', ({ target }) => {
      const { scrollHeight, scrollTop, clientHeight } = target;
      this.isBottom = !((scrollHeight - scrollTop) > clientHeight + this.eps);
      if (this.isBottom) {
        this.count = 0;
      }
    });
  },
  methods: {
    showImage(item) {
      this.showDialog = true;
      this.src = item.file.data;
    },
    async scrollToEnd() {
      const ref = this.$refs.chatView;
      ref.scrollTop = ref.scrollHeight;
      await new Promise(resolve => setTimeout(resolve, 500));
      if ((ref.scrollHeight - ref.scrollTop) > ref.clientHeight + this.eps) {
        await this.scrollToEnd();
      }
    },
    download(url) {
      document.location.href = url;
    }
  }
};
</script>

<style scoped>
.vm-chat-view-wrap {
  position: relative;
  flex: auto;
  overflow: hidden;
  height: 100%;
}
.vm-to-bottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
  border: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  outline: 0;
}
.vm-counter {
  align-items: center;
  position: absolute;
  top: -9px;
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: rgb(88, 73, 207);
  font-size: 10px;
  color: #fff;
  border-radius: 50%;
}
.vm-to-bottom i {
  font-size: 26px;
  font-weight: 300;
  color: #262626;
}
.vm-chat-view {
  flex: auto;
  overflow: auto;
  padding: 24px;
  height: 100%;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all 150ms;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.vm-image-dialog >>> .vm-dialog-content {
  z-index: 15;
}
.vm-image-dialog >>> img {
  max-height: 85vh;
  min-height: 100px;
  min-width: 100px;
  padding: 12px;
}


::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>